// extracted by mini-css-extract-plugin
export default {"campaignForm":"CampaignForm_campaignForm__xHABL","actions":"CampaignForm_actions__5c+rR","saveBtn":"CampaignForm_saveBtn__U8FCn","deleteBtn":"CampaignForm_deleteBtn__BjUT+"};